import isFunction from "lodash/isFunction";
import {
  useActivityCompareStore,
  useActivityCompareStoreActions
} from "PFApp/activities/show/store/activity_compare/use_activity_compare_store";
import Table from "PFComponents/table";
import { Tile } from "PFComponents/tile";

import { ShortlistTableEntry } from "../../../../activity_tabs.utils";
import { useMatchesShortlistTableColumns } from "../../../../hooks/use_matches_shortlist_table_columns";

type ShortlistsTableViewProps = {
  shortlistsEntries: ShortlistTableEntry[];
  isLoading: boolean;
};

export const ShortlistsTableView = ({ shortlistsEntries, isLoading }: ShortlistsTableViewProps) => {
  const compareIds = useActivityCompareStore((state) => state.compareIds);
  const { setCompareIds } = useActivityCompareStoreActions();
  const { generateColumns } = useMatchesShortlistTableColumns<ShortlistTableEntry>({
    isShortlistTabActive: true
  });

  return (
    <Tile variant="light" paddingVariant="lg" qaId="ActivityShortlistsTabTableContainer">
      <Table<ShortlistTableEntry>
        isLoading={isLoading}
        tableData={shortlistsEntries}
        generateColumns={generateColumns}
        rowSelection={compareIds}
        onRowSelectionChange={(newSelection) =>
          setCompareIds(isFunction(newSelection) ? newSelection(compareIds) : newSelection)
        }
        getRowId={({ shortlist }) => String(shortlist.profile.id)}
        enableRowSelection
        enableMultiRowSelection
        compact
      />
    </Tile>
  );
};
